<template>
<div>
  <!--<sign-up :visible.sync="signUpVisible"></sign-up>-->
  <el-dialog :visible="visible" width="30%" @update:visible="updateVisible">
    <div v-if="user">
      <table>
        <tr><td width="150px">User ID:</td><td v-text="user.id"></td></tr>
        <tr><td>User Name:</td><td v-text="user.username"></td></tr>
        <tr><td>Email:</td><td v-text="user.email"></td></tr>
      </table>
      <div>
        <div style="float: right" v-if="user">
          <el-button type="warning" @click.native="submitLogout">Logout</el-button>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>

    <div v-if="!user && show==='signin'">
      <el-form @keyup.enter.native="submitSignin" :model="signinForm" label-width="120px" label-position="left">
        <el-form-item label="User Name">
          <el-input v-model="signinForm.username" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Password">
          <el-input type="password" v-model="signinForm.password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>

      <div style="margin-bottom:10px"><i>No account? <span class="link" @click="show='signup'">Signup here</span></i></div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="updateVisible(false)">Cancel</el-button>
        <el-button type="primary" @click="submitSignin">Login</el-button>
      </div>
    </div>

    <div v-if="!user && show==='signup'">
      <el-form @keyup.enter="submitSignup" label-position="left" label-width="150px" :model="signupForm">
        <el-form-item label="User Name">
          <el-input v-model="signupForm.username" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Password">
          <el-input type="password" v-model="signupForm.password1" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Confirm Password">
          <el-input type="password" v-model="signupForm.password2" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Email">
          <el-input v-model="signupForm.email" auto-complete="off"></el-input>
        </el-form-item>

      </el-form>

      <div style="margin-bottom:10px"><i>Return to <span class="link" @click="show='signin'">login</span></i></div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="updateVisible(false)">Cancel</el-button>
        <el-button type="warning" @click="submitSignup">Sign Up</el-button>
      </div>
    </div>

  </el-dialog>
</div>
</template>

<script>
// import SignUp from '@/components/SignUp'

export default {
  name: 'user',

  data () {
    return {
      show: 'signin',
      signinForm: {
        username: '',
        password: ''
      },
      signupForm: {
        username: '',
        password1: '',
        password2: ''
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.user
    }
  },

  props: ['visible'],

  methods: {
    updateVisible (val) {
      this.$emit('update:visible', val)
    },

    submitLogout () {
      this.$store.dispatch('logout')
    },

    submitSignin () {
      this.$store.dispatch('login', this.signinForm)
    },

    submitSignup () {
      this.$store.dispatch('signUp', this.signupForm)
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog {
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.8);
}

.loginPage {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -150px;
  margin-left: -175px;
  width: 350px;
  min-height: 300px;
  padding: 30px 20px 20px;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: #fff;
}

.loginPage p {
  color: red;
  text-align: left;
}

.link {
  cursor: pointer;
  text-decoration: underline;
}

</style>
